/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { LabDefinitionViewModel } from './LabDefinitionViewModel'; 

export function getLabDefinitionOptions(id: string, onSuccess?: (result: LabDefinitionViewModel) => void) {
	return queryOptions({
		queryKey: ['lab-definition', id],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/frequencies/definitions/queries/getlabdefinition/' + id;
			const resp = await axios.get<LabDefinitionViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id)
	});
}